import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { TableEntityConfigurationComponent } from './entity-configuration/entity-configuration.component';
import { TableEmailFieldsComponent } from './email-fields/email-fields.component';
import { TableCampaignComponent } from './campaign/campaign.component';
import { TableConfigurationOCRComponent } from './configuration-ocr/configuration-ocr.component';
import { TableConfigurationSSOComponent } from './configuration-sso/configuration-sso.component';
import { TableEntityDetailsComponent } from './entity-details/entity-details.component';
import { TablePermissionsComponent } from './permissions/permissions.component';

const components =
    [
        TableCampaignComponent,
        TableConfigurationOCRComponent,
        TableConfigurationSSOComponent,
        TableEmailFieldsComponent,
        TableEntityDetailsComponent,
        TableEntityConfigurationComponent,
        TablePermissionsComponent
    ];

const componentsModules = [

]

@NgModule(
    {
        declarations: [components],
        exports: [
            components,
            componentsModules
        ],
        imports: [
            CommonModule,
            IonicModule,
            RouterModule,
            componentsModules
        ]
    })
export class EntityTablesComponentsModule { }
